import {
  Card,
  CardActionArea,
  CardContent,
  Grow,
  Typography,
} from "@material-ui/core"
import { Image, Transformation } from "cloudinary-react"
import { isEmpty } from "lodash"
import PropTypes from "prop-types"
import { useHistory } from "react-router"
import { Link } from "react-router-dom"
import grid from "~/assets/Sidebar/feather-grid-black.svg"
import Box from "~/components/Common/Box"
import DraftPublishedBox from "~/components/Common/DraftPublishedBox"
import HoverText from "~/components/Common/HoverText"
import useStyles from "./styles"

const PathCard = ({ path }) => {
  const classes = useStyles()
  const history = useHistory()

  return (
    <Grow in={true} timeout={350} style={{ transformOrigin: "center" }}>
      <Box className={classes.container} style={{ cursor: "pointer" }}>
        <Card className={classes.root} raised={true} elevation={0}>
          <CardActionArea
            to={`/learning-paths/${path.id}/content`}
            component={Link}
          >
            {!isEmpty(path.badge_image) && (
              <Box className={classes.badgeBox}>
                <Image
                  publicId={path.badge_image.public_id}
                  style={{
                    verticalAlign: "bottom",
                    height: "140px",
                    width: "140px",
                    borderRadius: "100%",
                  }}
                >
                  <Transformation
                    crop="fill"
                    gravity="auto"
                    aspectRatio="1:1"
                  />
                </Image>
              </Box>
            )}
            {isEmpty(path.badge_image) && <Box className={classes.cardMedia} />}
            <CardContent>
              <Box display="flex" alignItems="center">
                <Typography variant="caption" className={classes.date}>
                  Last Updated {path?.updated?.format("M/D/YYYY")}
                </Typography>
              </Box>
              <Box marginTop="8px" height="70px">
                <HoverText
                  variant="h5"
                  className={classes.title}
                  size={50}
                  data={path?.name}
                />
              </Box>
              <Box
                display="flex"
                marginTop={1.5}
                alignItems="center"
                justifyContent="space-between"
              >
                <Box display="flex" alignItems="center">
                  <Typography
                    color="primary"
                    variant="subtitle1"
                    className={classes.lessons}
                  >
                    {path?.courses?.length}
                  </Typography>
                  <img src={grid} alt="" className={classes.image} />
                </Box>
                <Box>
                  <DraftPublishedBox
                    published={path.published}
                    has_been_published={path.has_been_published}
                    archived={path.archived}
                    clickable
                  />
                </Box>
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      </Box>
    </Grow>
  )
}

PathCard.propTypes = {
  path: PropTypes.object,
}

export default PathCard
